import * as React from "react";
import axios from 'axios';
import SongCardListScroll from '../SongCardListScroll';


const hocLoadSongs = (apiUrl) => {

    return (
        async (page, itemsPerPage) => {

            // const host = 'http://localhost:3000';
            const skip = itemsPerPage * page;

            const res = await axios({
                method: 'GET',
                url: `${apiUrl}&limit=${itemsPerPage}&skip=${skip}`,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
            });

            return res.data;
        })
};

const emptyUpDownHandler = () => {};

const SongCardListScrollWithData = (props) => {

    return <SongCardListScroll
        loadMoreItems={hocLoadSongs(props.apiUrl)}
        upVote={emptyUpDownHandler}
        downVote={emptyUpDownHandler}
        {...props}/>;

};

export default SongCardListScrollWithData;



// WEBPACK FOOTER //
// ./components/songs/hoc/SongCardListScrollWithData.tsx